import developmentConfig from './development';
import productionConfig from './production';
import stagingConfig from './staging';

const currentEnv = import.meta.env.VITE_APP_ENV || 'development';

let envConfig;
switch (currentEnv) {
  case 'production':
    envConfig = productionConfig;
    break;
  case 'development':
    envConfig = developmentConfig;
    break;
  case 'staging':
    envConfig = stagingConfig;
    break;
  default:
    envConfig = developmentConfig;
    break;
}

export default envConfig;
